import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    flowType: 'default',
    currentStepIndex: 0,
    currentSubstepIndex: 0,
    navigationDirection: null, // 'forward', 'backward', or null
};

const travelInsuranceFlowSlice = createSlice({
    name: 'travelInsuranceFlow',
    initialState,
    reducers: {
        setTravelFlowType: (state, action) => {
            const { type, currentStepIndex, currentSubstepIndex } = action.payload;
            state.flowType = type;
            state.currentStepIndex = currentStepIndex || 0;
            state.currentSubstepIndex = currentSubstepIndex || 0;
        },
        setTravelCurrentStepIndex: (state, action) => {
            const newStepIndex = action.payload;
            const direction = newStepIndex > state.currentStepIndex ? 'forward' : 
                            newStepIndex < state.currentStepIndex ? 'backward' : null;
            state.currentStepIndex = newStepIndex;
            state.navigationDirection = direction;
        },
        setTravelCurrentSubstepIndex: (state, action) => {
            const newSubstepIndex = action.payload;
            const direction = newSubstepIndex > state.currentSubstepIndex ? 'forward' : 
                            newSubstepIndex < state.currentSubstepIndex ? 'backward' : null;
            state.currentSubstepIndex = newSubstepIndex;
            state.navigationDirection = direction;
        },
        setNavigationDirection: (state, action) => {
            state.navigationDirection = action.payload;
        },
        resetTravelFlow: (state) => {
            return initialState;
        },
    },
});

export const {
    setTravelFlowType,
    setTravelCurrentStepIndex,
    setTravelCurrentSubstepIndex,
    setNavigationDirection,
    resetTravelFlow,
} = travelInsuranceFlowSlice.actions;

export const selectTravelFlowType = (state) => state.travelInsuranceFlow.flowType;
export const selectTravelCurrentStepIndex = (state) => state.travelInsuranceFlow.currentStepIndex;
export const selectTravelCurrentSubstepIndex = (state) => state.travelInsuranceFlow.currentSubstepIndex;
export const selectNavigationDirection = (state) => state.travelInsuranceFlow.navigationDirection;

export default travelInsuranceFlowSlice.reducer;